// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.basketForm-form[data-v-1ad4df88]{display:flex;flex-direction:column;justify-content:space-between}.basketForm-form .form-actions[data-v-1ad4df88]{align-self:flex-end}.basketForm-form .form-actions button[data-v-1ad4df88]{min-width:200px}.basketForm-form .form-actions button[data-v-1ad4df88]:not(:only-child){margin-left:20px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
